import { useLocation, useNavigate } from "react-router";
import { useEffect, useMemo } from "react";
import { Alert, Box, Snackbar, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import SignIn from "../signin/signin";
import useAuth from "../../../shared/hooks/useAuth";
import CustomSpinner from "../../../shared/components/customSpinner/customSpinner";
import { RootState } from "../../../store/store";
import ForgotPassword from "../../forgotPassword/forgotPassword";
import "./authentication.scss";
import { ReactComponent as THSNow } from "../../../shared/assets/ths_now/THS_NOW.svg"
import { PAGES_URL } from "../../../shared/constants/constants";

const Authentication = () => {
  const auth = useAuth(true); // Use stable value instead of Math.random()
  const location = useLocation();
  const navigate = useNavigate();
  const storeSigninState = useSelector((state: RootState) => state.authentication);

  const el = useMemo(() => {
    switch (auth) {
      case false:
        return (
          <Stack>
            {location.pathname === "/forgotPassword" ? (
              <ForgotPassword />
            ) : (
              <SignIn />
            )}
          </Stack>
        );
      default:
        return <CustomSpinner />;
    }
  }, [auth, location.pathname]);

  const snackBarEl = useMemo(() => {
    if (storeSigninState.error) {
      return (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={4000}
          open={true}
        >
          <Alert
            severity="error"
            sx={{ width: "100%", fontWeight: "600" }}
            variant="filled"
          >
            {storeSigninState.error}
          </Alert>
        </Snackbar>
      );
    }
  }, [storeSigninState.error]);

  useEffect(() => {
    if (auth) {
      navigate(PAGES_URL.HOME);
    }
  }, [auth, navigate]);

  return (
    <Box >
      {el}
      {snackBarEl}
    </Box>
  );
};

export default Authentication;
